<script>

    // LocationBar.svelte

    // 4/29 - attempting to simplify the SearchPage

    import { onMount } from 'svelte';
    import { clearAlert } from '../../stores/AlertsStore';

    // TCARE components
    // import Textfield from '@smui/textfield';
    import ValuePicker from '../common/ValuePicker.svelte';
    import DistanceUnitRadios from '../common/DistanceUnitRadios.svelte';

    // SMUI components

    // 5/11 - NEW ARCHITECTURE
    export let store;                                               // Search object

    const radiusValues = [
        {label: '1', value: 1},
        {label: '5', value: 5},
        {label: '10', value: 10},
        {label: '25', value: 25},
        {label: '50', value: 50},
        {label: '100', value: 100}
    ]


    onMount(() => {
    })

    const onPostalCodeClick = () => {
        clearAlert();
    }

</script>

<style>
    .location-bar {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    /*
    .location-bar .postal-code {
        min-width: 150px;
    }
    */

    @media screen and (max-width: 600px) {
        /*
        .location-bar .postal-code {
            min-width: 120px;
        }
        */
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="location-bar">
    <div class="flex-row jc-start">
        <!--
        <div class="postal-code">
            <Textfield bind:value={$store.location.postalCode} 
                on:click={onPostalCodeClick}
                label="ZIP Code"
            />
        </div>
        -->
        <ValuePicker bind:value={$store.distance} values={radiusValues}/>
        <div class="spacer-w-15"></div>
        <DistanceUnitRadios bind:selectedValue={$store.distanceUnit}/>
    </div>
</div>
